<template>
  <div class="v-modal" :style="{zIndex}" v-scrollbar>
    <div class="mask"></div>
    <slot/>
  </div>
</template>

<script>
const modalGroup = document.body.appendChild(Element.create("div")),
  queue = [];
modalGroup.classList.add("v-modal-group");
window.on("keyup", e =>
  (({
    Escape: () => queue.length && queue[queue.length - 1].close()
  }[e.key] || (() => {}))())
);
export default {
  props: {
    width: {
      default: ""
    },
    height: {
      default: ""
    }
  },
  data() {
    return {
      zIndex: -1
    };
  },
  methods: {
    open() {
      queue.push(this);
      this.zIndex = queue.indexOf(this);
    },
    close() {
      this.zIndex = -1;
      this.remove();
      this.$el.remove();
    },
    remove() {
      let index = queue.indexOf(this);
      index == -1 || queue.splice(index, 1);
    }
  },
  mounted() {
    modalGroup.appendChild(this.$el);
  },
  destroyed() {
    this.remove();
    this.$el.remove();
  }
};
</script>

<style lang="less">
.v-modal-group {
  top: 0px;
  left: 0px;
  right: 0px;
  position: fixed;
  > .v-modal {
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: -1;
    overflow: auto;
    position: fixed;
    box-sizing: border-box;
    > .mask {
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      position: fixed;
      background-color: rgba(0, 0, 0, 0.3);
    }
    &:hover,
    &:active {
      > .v-scrollbar-horizontal,
      > .v-scrollbar-vertical {
        background-color: rgba(255, 255, 255, 0.6);
      }
    }
    > .v-scrollbar-horizontal,
    > .v-scrollbar-vertical {
      &:hover,
      &:active {
        background-color: rgba(255, 255, 255, 0.7);
      }
    }
  }
}
</style>

